import { GET_STATS_USER_CONNECTED_REQUESTED } from "../types/types";

export const getStatsForConnectedUser = (requestName, queryParams) => ({
    type: GET_STATS_USER_CONNECTED_REQUESTED,
    payload: {
        requestName,
        queryParams
    }
});